import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { CacheService } from '../../../shared/services/cache.service';
import { CommonService } from '../../../shared/services/common.service';
import { Utils } from '../../../shared/Utils/utils';
import { DateConstants } from '../../constants/date.constants';
import { InvoiceColumn, InvoicePrintStatus, OrderStatusConstants, SortOrder } from '../../constants/reports.constants';
import { OperatingCountryEnums } from '../../enums/countries.enums';
import { NotificationType } from "../../enums/notification-types.enum";
import { PrintStatusEnum } from '../../enums/print-status.enum';
import { AppConfigService } from '../../services/app-config.service';
import { CustomerService } from '../../services/customer.service';
import { OrderService } from '../../services/order.service';
import { ReportService } from '../../services/report.service';
import { OrderStatus, ShippingType } from '../../enums/order-source-type';
import { Permission } from '../../../common/enums/permission.enum';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { StoreMetaDataConstants } from '../../constants/store-metadata.constants';
import { OrderSourceTypes } from '../../enums/order-source.enum';
var InvoiceReportComponent = /** @class */ (function () {
    function InvoiceReportComponent(_customerService, _cacheService, _formbuilder, _orderService, _reportService, _translateService, _commonService, _appConfigService) {
        this._customerService = _customerService;
        this._cacheService = _cacheService;
        this._formbuilder = _formbuilder;
        this._orderService = _orderService;
        this._reportService = _reportService;
        this._translateService = _translateService;
        this._commonService = _commonService;
        this._appConfigService = _appConfigService;
        this.operatingCountries = [];
        this.countries = [];
        this.stores = [];
        this.businessEntities = [];
        this.currentDate = new Date();
        this.isSubmitted = false;
        this.isRunLoading = false;
        this.isPrintLoading = false;
        this.dataLoadedCount = 0;
        this.momentConstructor = moment.default || moment;
        this.dateRangeDuration = 1;
        this.isShowReport = false;
        this.pageSizes = ["50", "100", "150", "200", "All"];
        this.pageNumber = 1;
        this.pageSize = 50;
        this.selectedPageSize = this.pageSize;
        this.pageCount = 0;
        this.reportResponse = [];
        this.printCopies = [1, 2, 3, 4, 5];
        this.invoiceOptions = ["Invoice", "Packing Slip"];
        this.productCenters = [];
        this.printStatusConst = InvoicePrintStatus;
        this.printStatusEnum = PrintStatusEnum;
        this.selectedOrders = [];
        this.selectAll = false;
        this.orderInvoiceResponse = [];
        this.showPrint = false;
        this.participatingCountries = [];
        this.pageQuantity = 2;
        this.showProductCenterPermissionErr = false;
        this.sortColumn = InvoiceColumn.ID;
        this.sortOrder = SortOrder.ASC;
        this.isDesc = false;
        this.invoiceColumnEnum = InvoiceColumn;
        this.sortOrderEnum = SortOrder;
        this.orderLogResponse = [];
        this.defaultLoad = true;
        this.orderStatuses = [
            { id: OrderStatus.Completed, status: OrderStatusConstants.COMPLETED },
            { id: OrderStatus.Processing, status: OrderStatusConstants.PROCESSING },
            { id: OrderStatus.Ready_For_Pickup, status: OrderStatusConstants.READY_FOR_PICK_UP },
            { id: OrderStatus.Shipped, status: OrderStatusConstants.Shipped }
        ];
        this.enableUpdateOrderCheckbox = false;
        this.hasServiceOrderUpdatePermissions = false;
        this.hasServiceOrderManagePermission = false;
        this.iosBrowserPrintStatus = true;
    }
    InvoiceReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.getCountries();
        this.getOperatingCountries();
        this.buildInvoicePrintForm();
        this.toDate = this.momentConstructor(this.currentDate);
        this.hasServiceOrderUpdatePermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.REPLACEMENT_ORDER_STATUS_UPDATE + "]"), AccessLevel.Customer_Service);
        this.hasServiceOrderManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.REPLACEMENT_ORDER_MANAGE + "]"), AccessLevel.Customer_Service);
        window.addEventListener('afterprint', function () {
            _this.showPrint = false;
        });
    };
    /**
     * To build reports form
     */
    InvoiceReportComponent.prototype.buildInvoicePrintForm = function () {
        this.invoicePrintForm = this._formbuilder.group({
            operatingCountry: ['', Validators.required],
            store: ['', [Validators.required]],
            productCenter: ['', [Validators.required]],
            printStatus: ['20', [Validators.required]],
            orderNumber: [''],
            fromDate: ['', [Validators.required, Utils.validateFromDate()]],
            toDate: ['', [Validators.required, Utils.validateToDate()]],
            printQuantity: [this.pageQuantity],
            printOption: ['', null],
            orderStatus: ['', [Validators.required]],
            updateDeliveryStatus: [false],
            updatePickupStatus: [false]
        });
        this.setDefaultDateAndValidataors();
    };
    Object.defineProperty(InvoiceReportComponent.prototype, "printOption", {
        get: function () {
            return this.invoicePrintForm && this.invoicePrintForm.controls['printOption'].value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * To change page size
     * @param  {number} pageSize
     * @returns void
     */
    InvoiceReportComponent.prototype.pageSizeChange = function (size) {
        this.pageNumber = 1;
        this.selectedPageSize = size;
        this.pageSize = size === "All" ? null : +size;
        this.onSubmitRunReport();
    };
    /**
     * To change page number
     * @param  {number} pageNumber
     */
    InvoiceReportComponent.prototype.pageChange = function (pageNumber) {
        if (pageNumber) {
            this.pageNumber = pageNumber;
            this.onSubmitRunReport();
        }
    };
    /**
     * To get all operating countries from configuration service
     */
    InvoiceReportComponent.prototype.getOperatingCountries = function () {
        var _this = this;
        this._customerService.getAllBusinessEntities().subscribe(function (response) {
            if (response) {
                _this.businessEntities = response;
                _this.getAllowedOperatingCountries();
            }
        }, function (error) {
            _this.businessEntities = [];
        });
    };
    /**
     * To get allowed Countries based on permissions
     */
    InvoiceReportComponent.prototype.getAllowedOperatingCountries = function () {
        var countryIds = [];
        if (this.userInfo && !this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(',');
                countryIds = countryIds ? countryIds : [];
                if (countryIds && countryIds.length > 0) {
                    var ids_1 = countryIds;
                    this.operatingCountries = this.businessEntities.filter(function (item) {
                        return ids_1.indexOf(item.id + '') !== -1;
                    });
                }
            }
            else {
                this.operatingCountries = [];
            }
        }
        else {
            this.operatingCountries = this.businessEntities;
        }
        this.operatingCountries.sort(function (item1, item2) {
            var country1 = item1.name.toLowerCase(), country2 = item2.name.toLowerCase();
            if (country1 < country2) {
                return -1;
            }
            if (country1 > country2) {
                return 1;
            }
            return 0;
        });
        var countryInfo = this.operatingCountries.find(function (country) { return country.id === OperatingCountryEnums.USA; });
        if (countryInfo) {
            // this.operatingCountries.splice(this.countries.indexOf(countryInfo), 1);
            // this.operatingCountries.splice(0, 0, countryInfo);
            this.invoicePrintForm.controls['operatingCountry'].setValue(countryInfo.id);
            this.getStoresByCountryCode(countryInfo.id, countryInfo.value);
            this.defaultLoad = false;
        }
        if (this.countries && this.countries.length > 0 && !countryInfo && !this.defaultLoad) {
            this.getStoresByCountryCode(this.operatingCountries[0].id, this.operatingCountries[0].value);
        }
    };
    /**
     * To get all countries from configuration service
     */
    InvoiceReportComponent.prototype.getCountries = function () {
        var _this = this;
        this._customerService.getAllCountries(true).subscribe(function (response) {
            if (response) {
                _this.countries = response;
                if (_this.operatingCountries && _this.operatingCountries.length > 0) {
                    _this.getStoresByCountryCode(_this.operatingCountries[0].id, _this.operatingCountries[0].value);
                }
            }
        }, function (error) {
            _this.countries = [];
        });
    };
    /**
     * To get operating country by country code
     */
    InvoiceReportComponent.prototype.getStoresByCountryCode = function (operatingCountryId, isoCodeThree) {
        var _this = this;
        this.operatingCountryCode = isoCodeThree ? isoCodeThree : this.operatingCountries.find(function (operatingCountry) { return operatingCountry.id === +operatingCountryId; }).value;
        this._customerService.getOperatingCountriesByCountryCode(this.operatingCountryCode, true).subscribe(function (response) {
            if (response && response.countriesUnderOperatingCountry && response.countriesUnderOperatingCountry.length > 0) {
                _this.stores = [];
                response.countriesUnderOperatingCountry.forEach(function (countryOperatingCountry) {
                    var countries = _this.countries.filter(function (country) { return country.titanPlatformEnabled && country.enrollmentEnabled && country.shopEnabled
                        && country.isocodeThree === countryOperatingCountry.countryCode; });
                    if (countries && countries.length > 0) {
                        _this.stores = _this.stores.concat(countries);
                    }
                });
                if (_this.stores && _this.stores.length === 1) {
                    var defaultStore = _this.stores[0];
                    _this.invoicePrintForm.patchValue({ store: defaultStore.countryId });
                    _this.onStoreChange(defaultStore.countryId);
                }
            }
            else {
                _this.stores = [];
            }
        }, function (error) {
            _this.stores = [];
        });
    };
    /**
     * On operating country change event
     */
    InvoiceReportComponent.prototype.onOperatingCountryChange = function (operatingCountryId) {
        this.invoicePrintForm.controls['printOption'].setValue('');
        this.orderNumberFormValueReset('store', '');
        this.orderNumberFormValueReset('productCenter', '');
        this.orderNumberFormValueReset('orderNumber', '');
        this.orderNumberFormValueReset('updatePickupStatus', false);
        this.orderNumberFormValueReset('updateDeliveryStatus', false);
        this.isShowReport = false;
        this.storeId = null;
        this.storeInfo = null;
        this.storeMetadata = null;
        this.productCenters = [];
        this.participatingCountries = [];
        this.selectedOrders = [];
        this.showProductCenterPermissionErr = false;
        this.getStoresByCountryCode(operatingCountryId);
    };
    /**
     * On store change event
     */
    InvoiceReportComponent.prototype.onStoreChange = function (id) {
        this.isShowReport = false;
        this.orderNumberFormValueReset('productCenter', '');
        this.orderNumberFormValueReset('orderNumber', '');
        this.orderNumberFormValueReset('updatePickupStatus', false);
        this.orderNumberFormValueReset('updateDeliveryStatus', false);
        this.storeId = null;
        this.storeInfo = null;
        this.storeMetadata = null;
        this.productCenters = [];
        this.participatingCountries = [];
        this.selectedOrders = [];
        this.showProductCenterPermissionErr = false;
        var countryCode = this.stores.filter(function (country) { return country.countryId === Number(id); })[0].isocodeThree;
        this.appConfig = this._appConfigService.getSettings(countryCode, null);
        this.getStoreInfo(countryCode);
    };
    /**
     * To get store info by countryCode
     */
    InvoiceReportComponent.prototype.getStoreInfo = function (countryCode) {
        var _this = this;
        this._orderService.getStoreInfo(countryCode).subscribe(function (response) {
            if (response) {
                _this.storeInfo = response;
                if (_this.storeInfo.timeZoneOffset.toString().startsWith("-")) {
                    _this.storeTimeZoneOffSet = _this.storeInfo.timeZoneOffset.toString();
                }
                else {
                    _this.storeTimeZoneOffSet = '+' + _this.storeInfo.timeZoneOffset;
                }
                _this.storeId = response.id;
                _this.getStoreMetaData(_this.storeId);
                _this.getProductCenterByStoreId(_this.storeId);
                _this.getParticipatingCountries(countryCode);
            }
            else {
                _this.storeInfo = null;
            }
        }, function (error) {
            _this.storeInfo = null;
        });
    };
    /**
     * Get store metadata
     * @param storeId
     */
    InvoiceReportComponent.prototype.getStoreMetaData = function (storeId) {
        var _this = this;
        this._commonService.getStoreMetaData(storeId).subscribe(function (response) {
            if (response) {
                _this.storeMetadata = response;
                _this.enableUpdateOrderCheckbox = ((_this.getStoreMetaDataPermissions() && _this.getStorePermissionsForUpdateOrders()) || _this.hasServiceOrderManagePermission);
            }
            else {
                _this.storeMetadata = null;
                _this.enableUpdateOrderCheckbox = false;
            }
        }, function (error) {
            _this.storeMetadata = null;
            _this.enableUpdateOrderCheckbox = false;
        });
    };
    /**
     * Get participating countries
     * @param storeId
     */
    InvoiceReportComponent.prototype.getParticipatingCountries = function (countryCode) {
        var _this = this;
        this._customerService.getParticipatingCountries(countryCode).subscribe(function (response) {
            if (response) {
                _this.participatingCountries = response;
            }
            else {
                _this.participatingCountries = [];
            }
        }, function (error) {
            _this.participatingCountries = [];
        });
    };
    /**
     * To get product centers by storeId
     */
    InvoiceReportComponent.prototype.getProductCenterByStoreId = function (storeId) {
        var _this = this;
        this._customerService.getProductCenter(storeId).subscribe(function (response) {
            if (response && response.length > 0) {
                _this.getAllowedProductCenters(response);
            }
            else {
                _this.productCenters = [];
            }
        }, function (error) {
            _this.productCenters = [];
        });
    };
    /**
     * Get agent allowed product centers
     * @param response
     */
    InvoiceReportComponent.prototype.getAllowedProductCenters = function (response) {
        var _this = this;
        var productCenterIds = [];
        this.productCenters = [];
        if (this.userInfo && !this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedProductCenters.length) {
                var allowedProductCenters = this.userInfo.allowedProductCenters.filter(function (item) { return item.storeId == _this.storeId; });
                if (allowedProductCenters && allowedProductCenters.length > 0) {
                    productCenterIds = productCenterIds.concat(allowedProductCenters[0].productCenters.split(','));
                    this.productCenters = response.filter(function (x) { return productCenterIds.indexOf(x.id.toString()) > -1; });
                    this.showProductCenterPermissionErr = false;
                }
                else {
                    this.showProductCenterPermissionErr = true;
                }
            }
            else {
                this.showProductCenterPermissionErr = true;
            }
        }
        else {
            this.showProductCenterPermissionErr = false;
            this.productCenters = response;
        }
        if (this.productCenters && this.productCenters.length === 1) {
            var defaultProdcutCenter = this.productCenters[0];
            this.invoicePrintForm.patchValue({ productCenter: defaultProdcutCenter.name });
            this.onChangeProductCenter();
        }
    };
    /**
     * Set Default Date & Validators for Ordres Report
     */
    InvoiceReportComponent.prototype.setDefaultDateAndValidataors = function () {
        var toDate = new Date();
        var fromDate = new Date();
        fromDate.setDate(toDate.getDate() - 3);
        this.fromDate = this.momentConstructor(new Date(fromDate));
        this.invoicePrintForm.get('printStatus').setValue("20");
        this.invoicePrintForm.controls['fromDate'].setValue(this.momentConstructor(new Date(fromDate)));
        this.invoicePrintForm.controls['toDate'].setValue(this.momentConstructor(this.toDate));
        this.invoicePrintForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(1, 'M')]);
        this.invoicePrintForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(1, 'M')]);
        this.invoicePrintForm.controls['fromDate'].updateValueAndValidity();
        this.invoicePrintForm.controls['toDate'].updateValueAndValidity();
        this.dateRangeDuration = 1;
    };
    /**
     * When form values are changed
     */
    InvoiceReportComponent.prototype.formValuesChanged = function () {
        this.isSubmitted = false;
        this.dataLoadedCount = 0;
    };
    /**
     * Update the date range validation for ToDate when change from Date
     */
    InvoiceReportComponent.prototype.fromDateChange = function () {
        var _this = this;
        this.formValuesChanged();
        setTimeout(function () {
            if (!_this.invoicePrintForm.controls['toDate'].valid
                && (_this.invoicePrintForm.controls['toDate'].hasError('monthRangeValidation')
                    || _this.invoicePrintForm.controls['toDate'].hasError('toDateValidation'))) {
                _this.invoicePrintForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(_this.dateRangeDuration, 'M')]);
                _this.invoicePrintForm.controls['toDate'].updateValueAndValidity();
            }
            else if (!_this.invoicePrintForm.controls['toDate'].valid
                && _this.invoicePrintForm.controls['toDate'].hasError('dayRangeValidation')
                || _this.invoicePrintForm.controls['toDate'].hasError('toDateValidation')) {
                _this.invoicePrintForm.controls['toDate'].setValidators([Validators.required, Utils.validateToDate(1, 'M')]);
                _this.invoicePrintForm.controls['toDate'].updateValueAndValidity();
            }
        }, 0);
    };
    /**
     * Update the date range validation for fromDate when change To Date
     */
    InvoiceReportComponent.prototype.toDateChange = function () {
        var _this = this;
        this.formValuesChanged();
        setTimeout(function () {
            if (!_this.invoicePrintForm.controls['fromDate'].valid
                && (_this.invoicePrintForm.controls['fromDate'].hasError('monthRangeValidation')
                    || _this.invoicePrintForm.controls['fromDate'].hasError('fromDateValidation'))) {
                _this.invoicePrintForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(_this.dateRangeDuration, 'M')]);
                _this.invoicePrintForm.controls['fromDate'].updateValueAndValidity();
            }
            else if (!_this.invoicePrintForm.controls['fromDate'].valid
                && (_this.invoicePrintForm.controls['fromDate'].hasError('dayRangeValidation')
                    || _this.invoicePrintForm.controls['fromDate'].hasError('fromDateValidation'))) {
                _this.invoicePrintForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate(1, 'M')]);
                _this.invoicePrintForm.controls['fromDate'].updateValueAndValidity();
            }
        }, 0);
    };
    /**
     * on click run report
     */
    InvoiceReportComponent.prototype.onSubmitRunReport = function (sortByColumn, sortOrder) {
        var _this = this;
        this.orderLogResponse = [];
        this.selectAll = false;
        this.selectedOrders = [];
        this.formattedFromDate = Utils.convertToSpecificDateFormat(moment(this.invoicePrintForm.controls['fromDate'].value), DateConstants.DOBFormat);
        this.formattedToDate = Utils.convertToSpecificDateFormat(moment(this.invoicePrintForm.controls['toDate'].value), DateConstants.DOBFormat);
        this.isRunLoading = true;
        this.sortColumn = sortByColumn ? sortByColumn : this.sortColumn;
        this.sortOrder = sortOrder ? sortOrder : this.isDesc ? this.sortOrderEnum.DESC : this.sortOrderEnum.ASC;
        var statusId = [];
        this.pageSize = this.selectedPageSize === 'All' ? null : this.pageSize;
        this.invoicePrintForm.controls['printOption'].setValue('');
        this.invoicePrintForm.controls['updatePickupStatus'].setValue(false);
        this.invoicePrintForm.controls['updateDeliveryStatus'].setValue(false);
        if (this.invoicePrintForm.controls['printStatus'].value == 'All') {
            statusId.push(this.printStatusEnum.Not_Printed);
            statusId.push(this.printStatusEnum.Printed);
        }
        else {
            statusId.push(this.invoicePrintForm.controls['printStatus'].value);
        }
        var orderStatusId = this.selectedOrderStatus();
        this._reportService.getOrderInvoiceReport(this.storeId, this.invoicePrintForm.controls['productCenter'].value, statusId, this.formattedFromDate, this.formattedToDate, this.pageSize, this.pageNumber, this.sortColumn, this.sortOrder, this.invoicePrintForm.controls['orderNumber'].value, orderStatusId).subscribe(function (response) {
            if (response && response.content && response.content.length > 0) {
                _this.reportResponse = response.content;
                _this.reportResponse.forEach(function (data) {
                    if (data.storePostedDate) {
                        data.storePostedDate = moment.utc(data.storePostedDate).format('DD-MMM-YYYY HH:mm:ss');
                    }
                });
                _this.isRunLoading = false;
                _this.pageSize = _this.pageSize ? _this.pageSize : response.totalCount;
                _this.pageCount = response.totalCount;
                _this.isShowReport = true;
            }
            else {
                var message = _this._translateService.get('reports.Orders not found for selected filter criteria');
                _this._commonService.createNotification('', message.value, NotificationType.ERROR);
                _this.reportResponse = [];
                _this.isRunLoading = false;
                _this.pageCount = 0;
                _this.isShowReport = false;
                _this.selectedOrders = [];
                _this.selectAll = false;
            }
        }, function (error) {
            var message = _this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            _this._commonService.createNotification('', message.value, NotificationType.ERROR);
            _this.reportResponse = [];
            _this.isRunLoading = false;
            _this.pageCount = 0;
            _this.isShowReport = false;
            _this.selectedOrders = [];
            _this.selectAll = false;
        });
    };
    InvoiceReportComponent.prototype.selectedOrderStatus = function () {
        if (this.invoicePrintForm.get('orderStatus').value == "All")
            return this.orderStatuses.map(function (status) { return status.id; });
        return [+this.invoicePrintForm.get('orderStatus').value];
    };
    /**
     * on click print report
     */
    InvoiceReportComponent.prototype.onSubmitPrintReport = function () {
        var _this = this;
        this.isPrintLoading = true;
        this.updateOrderStatues();
        this._reportService.getOrderInvoicePrintReport(this.storeId, this.selectedOrders).subscribe(function (response) {
            if (response && response.length > 0) {
                _this.orderInvoiceResponse = response;
                _this.isPrintLoading = false;
                _this.showPrint = true;
                setTimeout(function () {
                    window.print();
                    _this.iosBrowserPrintStatus = false;
                }, 0);
                _this.updateOrderInvoicePrintStatus();
            }
            else {
                _this.orderInvoiceResponse = [];
                _this.isPrintLoading = false;
                _this.showPrint = false;
            }
        }, function (error) {
            var message = _this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            _this._commonService.createNotification('', message.value, NotificationType.ERROR);
            _this.orderInvoiceResponse = [];
            _this.isPrintLoading = false;
            _this.showPrint = false;
        });
    };
    InvoiceReportComponent.prototype.onClickWebOrderNnmber = function (webOrderId) {
        var _this = this;
        // this.searchService.log.startDate;
        this.orderLogResponse = [];
        var startDate = new Date(this.formattedFromDate);
        var endDate = new Date(this.formattedToDate);
        startDate = new Date(startDate.getTime() - (startDate.getTimezoneOffset() * 60 * 1000));
        endDate = new Date(endDate.getTime() - (endDate.getTimezoneOffset() * 60 * 1000));
        endDate.setHours(23);
        endDate.setMinutes(59);
        endDate.setSeconds(59);
        var request = {
            "messageType": 0,
            "refId": webOrderId,
            "startDate": startDate,
            "endDate": endDate,
            "pageNumber": 1,
            "pageSize": 10,
            "export": false
        };
        this._reportService.getOrderLogsFromDI(request, true, null).subscribe(function (response) {
            if (response && response.requestLookUpDetails && response.requestLookUpDetails.length > 0) {
                _this.orderLogResponse = response.requestLookUpDetails;
            }
        });
    };
    /**
     * Update Order invoice print status
     */
    InvoiceReportComponent.prototype.updateOrderInvoicePrintStatus = function () {
        var _this = this;
        var userName = ((this.userInfo.firstName ? this.userInfo.firstName : "")
            + (this.userInfo.middleName ? " " + this.userInfo.middleName : "")
            + (this.userInfo.lastName ? " " + this.userInfo.lastName : "")).replace("  ", " ").trim();
        this._reportService.updateOrderInvoicePrintStatus(this.selectedOrders, this.userInfo.userId, userName).subscribe(function (response) {
            if (response && response.status) {
                _this.onSubmitRunReport();
            }
            else {
                var message = _this._translateService.get('reports.Error saving invoice print status');
                _this._commonService.createNotification('', message.value, NotificationType.ERROR);
            }
        }, function (error) {
            var message = _this._translateService.get('reports.Error saving invoice print status');
            _this._commonService.createNotification('', message.value, NotificationType.ERROR);
        });
    };
    /**
     * On print quantity change event
     */
    InvoiceReportComponent.prototype.onPrintQuantityChange = function (quantity) {
        this.pageQuantity = quantity;
    };
    /**
     * On check box click event
     */
    InvoiceReportComponent.prototype.onOrderSelect = function (event, orderInvoice) {
        if (event.target.checked) {
            if (orderInvoice) {
                if (!orderInvoice.isSelected) {
                    orderInvoice.isSelected = true;
                    this.selectedOrders.push(orderInvoice.id);
                }
            }
            else {
                if (this.reportResponse.length) {
                    for (var _i = 0, _a = this.reportResponse; _i < _a.length; _i++) {
                        var report = _a[_i];
                        if (!report.isSelected) {
                            report.isSelected = true;
                            this.selectedOrders.push(report.id);
                        }
                    }
                    this.selectAll = this.reportResponse.every(function (report) { return report.isSelected === true; });
                }
            }
            this.selectAll = this.reportResponse.every(function (report) { return report.isSelected === true; });
        }
        else {
            if (orderInvoice) {
                orderInvoice.isSelected = false;
                this.selectedOrders.splice(this.selectedOrders.indexOf(orderInvoice.id), 1);
            }
            else {
                if (this.reportResponse.length) {
                    for (var _b = 0, _c = this.reportResponse; _b < _c.length; _b++) {
                        var report = _c[_b];
                        report.isSelected = false;
                        this.selectedOrders.splice(this.selectedOrders.indexOf(report.id), 1);
                    }
                    this.selectAll = this.reportResponse.every(function (report) { return report.isSelected === true; });
                }
            }
            this.selectAll = false;
        }
    };
    /**
     * track by index
     * @param index
     * @returns
     */
    InvoiceReportComponent.prototype.trackByItem = function (index) {
        return index;
    };
    /**
     * On change event for product center
     */
    InvoiceReportComponent.prototype.onChangeProductCenter = function () {
        this.selectedOrders = [];
        this.isShowReport = false;
    };
    /**
     * Sort by column name
     * @param sortColumn
     */
    InvoiceReportComponent.prototype.sortByColumn = function (sortColumn) {
        this.isDesc = (this.sortColumn == sortColumn || sortColumn == "") ? !this.isDesc : this.isDesc;
        this.sortColumn = sortColumn;
        this.sortOrder = this.isDesc ? this.sortOrderEnum.DESC : this.sortOrderEnum.ASC;
        this.onSubmitRunReport();
    };
    /**
     * To reset order number form value
     */
    InvoiceReportComponent.prototype.orderNumberFormValueReset = function (control, value) {
        this.invoicePrintForm.get(control).setValue(value);
        this.invoicePrintForm.get(control).markAsPristine();
        this.invoicePrintForm.get(control).markAsUntouched();
    };
    InvoiceReportComponent.prototype.populatePickupOrders = function (isPickUp) {
        var _this = this;
        var webOrdeIDS = [];
        var maxLimitSelection = 25;
        if (this.selectedOrders && !!this.selectedOrders.length && this.reportResponse && !!this.reportResponse.length) {
            var _loop_1 = function (i) {
                var orders = this_1.reportResponse.find(function (orders) { return orders.id == _this.selectedOrders[i]; });
                if (orders && orders.orderStatusId == OrderStatus.Processing &&
                    orders.webOrderId && orders.deliveryPreferenceId == ShippingType.PICKUP &&
                    orders.orderSource && orders.orderSource.toLowerCase() != OrderSourceTypes.POS.toLowerCase() && isPickUp) {
                    webOrdeIDS.push(orders.webOrderId);
                }
                else if (orders && orders.orderStatusId == OrderStatus.Processing &&
                    orders.webOrderId && orders.deliveryPreferenceId == ShippingType.DELIVERY &&
                    orders.orderSource && orders.orderSource.toLowerCase() != OrderSourceTypes.POS.toLowerCase() && !isPickUp) {
                    webOrdeIDS.push(orders.webOrderId);
                }
                if (webOrdeIDS.length == maxLimitSelection)
                    return "break";
            };
            var this_1 = this;
            for (var i = 0; i <= this.selectedOrders.length - 1; i++) {
                var state_1 = _loop_1(i);
                if (state_1 === "break")
                    break;
            }
        }
        return webOrdeIDS;
    };
    InvoiceReportComponent.prototype.getPermissionsForUpdateOrders = function () {
        var hasServiceOrderUpdatePermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.REPLACEMENT_ORDER_STATUS_UPDATE + "]"), AccessLevel.Customer_Service);
        var hasServiceOrderManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.REPLACEMENT_ORDER_MANAGE + "]"), AccessLevel.Customer_Service);
        return (hasServiceOrderUpdatePermissions || hasServiceOrderManagePermission);
    };
    InvoiceReportComponent.prototype.getStoreMetaDataPermissions = function () {
        var orderStatusUpdateAttribute = this.storeMetadata && !!this.storeMetadata.length && this.storeMetadata.filter(function (x) { return (x.attribute &&
            (x.attribute.toLowerCase() === (StoreMetaDataConstants.ENABLE_ORDER_STATUS_UPDATE.toLowerCase() || StoreMetaDataConstants.ENABLE_SERVICE_ORDER.toLowerCase()))); });
        return orderStatusUpdateAttribute && !!orderStatusUpdateAttribute.length && orderStatusUpdateAttribute.some(function (attribute) { return attribute.metaDataValue && attribute.metaDataValue.toLowerCase() === 'true'; });
    };
    InvoiceReportComponent.prototype.getStorePermissionsForUpdateOrders = function () {
        var orderStatusUpadte = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.ORDER_STATUS_UPDATE + "]"), AccessLevel.Store, this.storeInfo ? this.storeInfo.id : null);
        return (this.hasServiceOrderUpdatePermissions || orderStatusUpadte);
    };
    InvoiceReportComponent.prototype.updateOrderStatues = function () {
        var _this = this;
        var orderStatus = this.invoicePrintForm.get('orderStatus').value;
        var updateStatus = this.invoicePrintForm.get('updatePickupStatus').value;
        var updateDeliveryStatus = this.invoicePrintForm.get('updateDeliveryStatus').value;
        if (this.enableUpdateOrderCheckbox && updateStatus && orderStatus && (orderStatus == "All" || orderStatus == OrderStatus.Processing)) {
            var orderIds = this.populatePickupOrders(true);
            if (orderIds && !!orderIds.length) {
                this._reportService.updateProcessingOrderStatus(orderIds, (this.userInfo && this.userInfo.userId))
                    .subscribe(function (res) {
                    if (res && res.success) {
                        var message = _this._translateService.get('reports.Order is Processing in Background, Please check after some time');
                        _this._commonService.createNotification('', message.value, NotificationType.SUCCESS);
                    }
                    else {
                        var message = _this._translateService.get('reports.Something Went Wrong While updating order statuses, Please try again after some time');
                        _this._commonService.createNotification('', message.value, NotificationType.ERROR);
                    }
                }, function (err) {
                    var message = _this._translateService.get('reports.Something Went Wrong While updating order statuses, Please try again after some time');
                    _this._commonService.createNotification('', message.value, NotificationType.ERROR);
                });
            }
            ;
        }
        if (this.enableUpdateOrderCheckbox && updateDeliveryStatus && orderStatus && (orderStatus == "All" || orderStatus == OrderStatus.Processing)) {
            var orderIds = this.populatePickupOrders(false);
            if (orderIds && !!orderIds.length) {
                var request = {
                    "webOrderIds": orderIds
                };
                this._reportService.updateDeliveryProcessingOrderStatus(request).subscribe(function (res) {
                    if (res && res.success) {
                        var message = _this._translateService.get('reports.Order is Processing in Background, Please check after some time');
                        _this._commonService.createNotification('', message.value, NotificationType.SUCCESS);
                    }
                    else {
                        var message = _this._translateService.get('reports.Something Went Wrong While updating order statuses, Please try again after some time');
                        _this._commonService.createNotification('', message.value, NotificationType.ERROR);
                    }
                }, function (err) {
                    var message = _this._translateService.get('reports.Something Went Wrong While updating order statuses, Please try again after some time');
                    _this._commonService.createNotification('', message.value, NotificationType.ERROR);
                });
            }
        }
    };
    InvoiceReportComponent.prototype.orderStatusChange = function () {
        var orderStatus = this.invoicePrintForm.get('orderStatus').value;
        if (orderStatus == "All" || orderStatus == OrderStatus.Processing) {
            this.invoicePrintForm.get('updatePickupStatus').enable();
            this.invoicePrintForm.get('updateDeliveryStatus').enable();
        }
        else {
            this.invoicePrintForm.get('updatePickupStatus').setValue(false);
            this.invoicePrintForm.get('updatePickupStatus').disable();
            this.invoicePrintForm.get('updateDeliveryStatus').setValue(false);
            this.invoicePrintForm.get('updateDeliveryStatus').disable();
        }
        this.invoicePrintForm.get('updatePickupStatus').updateValueAndValidity();
        this.invoicePrintForm.get('updateDeliveryStatus').updateValueAndValidity();
    };
    InvoiceReportComponent.prototype.onFocusOut = function () {
        this.showPrint = false;
    };
    return InvoiceReportComponent;
}());
export { InvoiceReportComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/invoice-report.component.ts.pre-build-optimizer.js